import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const LikeFilled = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.72577 4.64213C3.92605 2.44658 7.53307 2.46007 9.81982 4.63793L9.82126 4.6393L11.975 6.70689L14.1251 4.64277C16.3253 2.44658 19.9329 2.45986 22.2198 4.63793L22.2287 4.64634C24.4239 6.8416 24.4238 10.3583 22.2286 12.5536L22.2231 12.559L11.975 22.4965L1.73017 12.5621L1.72855 12.5605C-0.575255 10.3648 -0.576182 6.83896 1.72577 4.64213Z"
  />,
  'LikeFilled'
)

export default LikeFilled
